export const FilterConferenceOptions = {
  all: 'all',
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  ended: 'ended',
};
